import { create } from 'zustand';

/**
 * A page that wants the whole width (spec 128 R4) — the builder, with its
 * palette, canvas and inspector beside the app sidebar, left the canvas 540px
 * of 1440. While active the shell shows the rail; the person can still expand
 * the sidebar, and that holds for the rest of the visit. Memory only: nothing
 * about it should outlive the page.
 */
interface FocusModeState {
  active: boolean;
  expanded: boolean;
  enter: () => void;
  leave: () => void;
  setExpanded: (expanded: boolean) => void;
}

export const useFocusModeStore = create<FocusModeState>((set) => ({
  active: false,
  expanded: false,
  enter: () => {
    set({ active: true, expanded: false });
  },
  leave: () => {
    set({ active: false, expanded: false });
  },
  setExpanded: (expanded) => {
    set({ expanded });
  },
}));
